module.exports = __webpack_public_path__ + "static/media/maintenance.8f010965.jpg";